import { Link } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { cn } from '@/lib/utils';
import { PUBLIC_BETA_URLS, PUBLIC_CORE_LINKS } from '../../ui-foundation';

type LegalLinksProps = {
  align?: 'left' | 'center';
  className?: string;
  hideWhenAuthenticated?: boolean;
  tone?: 'app' | 'public';
};

const WEB_PUBLIC_LINK_PATHS = {
  about: '/about',
  privacy: '/privacy',
  gdpr: '/gdpr',
  terms: '/terms',
  communityGuidelines: '/community-guidelines',
  contactSupport: '/contact-complaints',
} as const;

const LINKS = PUBLIC_CORE_LINKS.map((link) => ({
  to: WEB_PUBLIC_LINK_PATHS[link.key],
  label: link.label,
}));

export default function LegalLinks({
  align = 'center',
  className,
  hideWhenAuthenticated = false,
  tone = 'app',
}: LegalLinksProps) {
  const { user } = useApp();

  if (hideWhenAuthenticated && user) return null;

  const wrapperAlignment = align === 'left' ? 'items-start text-left' : 'items-center text-center';
  const rowAlignment = align === 'left' ? 'justify-start' : 'justify-center';
  const linkClass = tone === 'public' ? 'adulting-accent hover:underline' : 'text-primary hover:underline';

  return (
    <div className={cn('flex flex-col gap-2', wrapperAlignment, className)}>
      <div className={cn('flex flex-wrap gap-x-4 gap-y-2 text-xs font-medium', rowAlignment)}>
        {LINKS.map((item) => (
          <Link key={item.to} to={item.to} className={linkClass}>
            {item.label}
          </Link>
        ))}
      </div>
      <p className="text-[11px] leading-relaxed text-muted-foreground">
        Questions about privacy, data rights, terms, or complaints?{' '}
        <Link to={WEB_PUBLIC_LINK_PATHS.contactSupport} className={linkClass}>
          Contact &amp; complaints
        </Link>{' '}
        or email{' '}
        <a href={`mailto:${PUBLIC_BETA_URLS.supportEmail}`} className={linkClass}>
          {PUBLIC_BETA_URLS.supportEmail}
        </a>
      </p>
    </div>
  );
}
